// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
// import fastClick from 'fastclick'
// fastClick.attach(document.body)
//为什么注释掉呢，因为加了这行代码苹果手机输入框聚焦会不灵敏非常难
import _ from 'underscore'
import Config from './api/config'
import Vuex from 'vuex'
import store from './store/store'
Vue.use(Vuex)
import axios from 'axios'
Vue.prototype.$axios = axios

// 为社么引入两个ui，因为一个满足不了需求，找不到一个完美契合项目需求的ui框架，如果你可以找到就换掉吧
// element主要用在了侧边栏的菜单组件，批量上传图片组件,刚发现竟然loading也用了，抱歉，还有下拉option，select组件，
// 看情况能改我就改回来吧，前期急于完成项目，后面如果我闲下来再优化吧。
// vant本想按需引入，一直报错，慌的一批只好全局引入，别学我。
import Vant from 'vant'
Vue.use(Vant)
import 'vant/lib/index.css'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

// 图片剪裁
import VueCropper from 'vue-cropper';
Vue.use(VueCropper);

// 全局引入
import H5Cropper from 'vue-cropper-h5'
Vue.use(H5Cropper)

// 一些自定义的函数方法
import {
  getToken,
  setToken,
  removeToken,
  getUserId,
  setUserId,
  removeUserId,
  getUserLogin,
  setUserLogin,
  removeUserLogin,
  getUserGrade,
  setUserGrade,
  removeUserGrade,
  getGradeName,
  setGradeName,
  removeGradeName,
  getShopUrl,
  setShopUrl,
  removeShopUrl,
  setWindow,
  getWindow,
  removeWindow,
  setUserStatus,
  getUserStatus,
  removeUserStatus,
  setCyf,
  getCyf,
  removeCyf,
  setNotice,
  getNotice,
  removeNotice,
  setProd,
  getProd,
  removeProd,
  setMetatitle,
  getMetatitle,
  getGradeAlert,
  setGradeAlert,
  removeGradeAlert
} from '@/utils/http'

Vue.prototype.getGradeAlert = getGradeAlert
Vue.prototype.setGradeAlert = setGradeAlert
Vue.prototype.removeGradeAlert = removeGradeAlert

Vue.prototype.setMetatitle = setMetatitle
Vue.prototype.getMetatitle = getMetatitle

Vue.prototype.getToken = getToken
Vue.prototype.setToken = setToken
Vue.prototype.removeToken = removeToken

Vue.prototype.getUserId = getUserId
Vue.prototype.setUserId = setUserId
Vue.prototype.removeUserId = removeUserId

Vue.prototype.getUserLogin = getUserLogin
Vue.prototype.setUserLogin = setUserLogin
Vue.prototype.removeUserLogin = removeUserLogin

Vue.prototype.getUserGrade = getUserGrade
Vue.prototype.setUserGrade = setUserGrade
Vue.prototype.removeUserGrade = removeUserGrade

Vue.prototype.getGradeName = getGradeName
Vue.prototype.setGradeName = setGradeName
Vue.prototype.removeGradeName = removeGradeName

Vue.prototype.getShopUrl = getShopUrl
Vue.prototype.setShopUrl = setShopUrl
Vue.prototype.removeShopUrl = removeShopUrl

Vue.prototype.setWindow = setWindow
Vue.prototype.getWindow = getWindow
Vue.prototype.removeWindow = removeWindow

Vue.prototype.setUserStatus = setUserStatus
Vue.prototype.getUserStatus = getUserStatus
Vue.prototype.removeUserStatus = removeUserStatus

Vue.prototype.setCyf = setCyf
Vue.prototype.getCyf = getCyf
Vue.prototype.removeCyf = removeCyf

Vue.prototype.setNotice = setNotice
Vue.prototype.getNotice = getNotice
Vue.prototype.removeNotice = removeNotice

Vue.prototype.setProd = setProd
Vue.prototype.getProd = getProd
Vue.prototype.removeProd = removeProd

// 材料网api
Vue.prototype.api = function (api_url, data, success, fail) {

  let post_data = _.http_build_query({
    token: unescape(getToken()), //unescape解码中文符号
    // token: 'mWObb2NnYqHPktHLncex64=', //unescape解码中文符
    data: _.json_encode(data || {})
  })

  axios.post(Config.api_url + api_url, post_data).then(resp => {
    if (resp.data.status == 1) {
      if (success) {
        success(resp.data);
      }
    } else {
      if (fail) {
        fail(resp.data);
        if (resp.data.result == '请登陆') {
          router.push('/login');
        }
      } else {
        if (resp.data.result == '请登陆') {
          router.push('/login');
        }
      }
    }
  });
}

// 材云发api
Vue.prototype.http = function (base_url, data, success, fail) {
  let post_data = _.http_build_query({
    token: '',
    data: _.json_encode(data || {})
  })
  axios.post(Config.base_url + base_url, post_data).then(resp => {
    if (resp.data.status == 1) {
      if (success) {
        success(resp.data);
      }
    } else {
      if (fail) {
        fail(resp.data);
      } else {
        alert(resp.data.result);
      }
    }
  });
}
Vue.config.productionTip = false

// 路由权限跳转钩子函数，路由拦截
// 不定向白名单
const whiteList = ['/login']
const whiteList_register = ['/register']
const whiteList_forget = ['/forget']
router.beforeEach((to, from, next) => {
  
  document.title = `${to.meta.title}|中国材料网`;
  setMetatitle(to.meta.title);
  store.commit("SET_META", to.meta.title);

  if (window._global.anotherToken) {
    let expireDays = 60 * 60 * 4;
    setToken(window._global.anotherToken, expireDays);
  }


  const role = getToken();
  if (role) {
    if (to.path === '/login') {
      next({
        path: '/'
      })
    } else if (to.path === '/register') {
      next({
        path: '/'
      })
    } else if (to.path === '/forget') {
      next({
        path: '/'
      })
    } else if (to.path === '/') {
      next({
        path: '/'
      })
    } else {
      next()
    }

  } else {
    // next()
    if (whiteList.indexOf(to.path) !== -1) {
      next()
    } else if (whiteList_register.indexOf(to.path) !== -1) {
      next()
    } else if (whiteList_forget.indexOf(to.path) !== -1) {
      next()
    }else {
      // console.log('123');
      next(`/login`)
    }

  }
})

import "@/assets/css/common.css"
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js